/*
 * Created By Vasim Hayat at 1/14/2020 4:01 PM
 *
 */

import {
	ModuleWithProviders,
	NgModule,
	OnDestroy,
	InjectionToken,
	Inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

import { FoundationModule } from '../../foundation.module';

import { FnMenuItemComponent } from './menu-item/fn-menu.item.component';
import { FnMenuLandingComponent } from './menu-landing/fn-menu-landing.component';
import { FnMenuSidebarComponent } from './sidebar/fn-menu-sidebar.component';
import { FnMenuEventService } from './service/fn-menu-event.service';
import { FnMenuDataService } from './service/fn-menu-data.service';
import { FnTranslateModule } from '../../i18n/index';
import { FnScrollbarModule } from '../scrollbar/index';

export * from './models/fn-menu.state';

export * from './menu-item/fn-menu.item.component';
export * from './menu-landing/fn-menu-landing.component';
export * from './sidebar/fn-menu-sidebar.component';

export * from './service/fn-menu-data.service';
export * from './service/fn-menu-event.service';

export interface MenuConfig {
	translatePath?: string;
}

@NgModule({ declarations: [
        FnMenuItemComponent,
        FnMenuLandingComponent,
        FnMenuSidebarComponent,
    ],
    exports: [
        FnMenuItemComponent,
        FnMenuLandingComponent,
        FnMenuSidebarComponent,
    ], imports: [FormsModule,
        CommonModule,
        FoundationModule,
        FnTranslateModule.forRoot(),
        FnScrollbarModule], providers: [FnMenuEventService, FnMenuDataService, provideHttpClient(withInterceptorsFromDi())] })
export class FnMenuModule {
	static forRoot(options?: MenuConfig): ModuleWithProviders<FnMenuModule> {
		return {
			ngModule: FnMenuModule,
			providers: [FnMenuEventService, FnMenuDataService],
		};
	}
}
